<template>
  <OmtStickedModal
    v-if="isOpen"
    @close="close"
  >
    <OmtTypography
      as="h1-bold"
      mb="24px"
      >Termo de Consentimento do Programa Cuidar+ Omint</OmtTypography
    >
    <OmtTypography
      as="p1"
      mb="16px"
      lineHeight="22px"
    >
      Ao participar do Check-up Digital Omint, você autoriza o tratamento dos seus dados de saúde para a avaliação
      preventiva, identificação de fatores de risco e elaboração de um plano de cuidados personalizado, em conjunto com
      a parceira Mar Saúde.
    </OmtTypography>
    <OmtTypography
      as="p1"
      mb="16px"
      lineHeight="22px"
    >
      As informações coletadas no questionário e nos exames serão utilizadas apenas para as finalidades do programa, com
      medidas de segurança adequadas e em conformidade com a legislação aplicável.
    </OmtTypography>
    <OmtTypography
      as="p1"
      mb="32px"
      lineHeight="22px"
    >
      Você poderá deixar de participar a qualquer momento, sem prejuízo da continuidade do seu plano de saúde.
    </OmtTypography>
    <template #footer>
      <OmtButton
        w="100%"
        @click="close"
      >
        <OmtTypography
          as="button-large"
          color="white"
        >
          Fechar
        </OmtTypography>
      </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    }
  }
};
</script>
